// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0246e2fd","455":"3f184b46","488":"b71b397c","977":"b7105688"}[chunkId] + ".chunk.js";
};